import type { ApiModels } from '@ori/global-api-client';
import { createContext } from 'react';

interface TypesContext {
  types:
    | ApiModels.GlobalCustomersAutoshipTypeDto[]
    | ApiModels.GlobalCustomersSubscriptionTypeDto[];
  isLoading: boolean;
}

export const typesContext = createContext<TypesContext>({} as TypesContext);

export const TypesProvider = typesContext.Provider;
